import Box from '@zenbusiness/zui/Box';
import { styled } from '@zenbusiness/zui/styles';

export const FocusGrid = styled(Box)(({ gridTemplateRows, justifyItems, alignItems }) => ({
  width: '100%',
  display: 'grid',
  gridTemplateRows: gridTemplateRows || 'auto',
  justifyItems: justifyItems || 'center',
  alignItems: alignItems || 'top',

  gridTemplateColumns: 'repeat(4, 1fr)',
  rowGap: '8px',
  columnGap: '8px',

  '@media (min-width: 600px) and (max-width: 899px)': {
    gridTemplateColumns: 'repeat(6, 1fr)',
    rowGap: '8px',
    columnGap: '8px'
  },
  '@media (min-width: 900px)': {
    gridTemplateColumns: 'repeat(12, 1fr)',
    rowGap: '12px',
    columnGap: '12px'
  }
}));
